/**
 * B10：价值创造页（p8v）交互 — 从 legacy-app.js 拆出。
 */
import { escapeHtml } from '../util/html.js';

/** @param {import('./portal-ui-deps.js').PortalUiDeps} deps */
export function initValueCreationUi(deps) {
  const {
    requestRuntime,
    showRuntimeError,
    setRuntimeProgress,
    getCurrentProjectId,
    getCurrentProjectInput,
    runProjectSkill,
  } = deps;

  let latestValueCreation = null;

  function collectValueCreationPayload() {
    const num = (id) => {
      const raw = document.getElementById(id)?.value;
      if (raw === '' || raw == null) return undefined;
      const value = Number(raw);
      return Number.isFinite(value) ? value : undefined;
    };
    const projectId = getCurrentProjectId();
    return {
      projectId: projectId && projectId !== 'draft' ? projectId : undefined,
      period: document.getElementById('vc-period')?.value.trim() || undefined,
      companyName: document.getElementById('vc-company')?.value.trim() || undefined,
      budget: {
        revenue: num('vc-budget-revenue'),
        ebitda: num('vc-budget-ebitda'),
        grossProfit: num('vc-budget-gp'),
        opex: num('vc-budget-opex'),
      },
      actual: {
        revenue: num('vc-actual-revenue'),
        ebitda: num('vc-actual-ebitda'),
        grossProfit: num('vc-actual-gp'),
        opex: num('vc-actual-opex'),
      },
    };
  }

  function renderValueCreationResult(output) {
    const result = output.result || output;
    latestValueCreation = result;
    document.getElementById('vc-title').textContent =
      `${result.companyName || '项目'} · ${result.period || ''} 价值创造`;
    document.getElementById('vc-summary').textContent = result.summary || '--';
    document.getElementById('vc-variance-list').innerHTML = (result.budgetVariance || []).map((row) => `
    <div style="margin-bottom:4px;">
      <strong>${escapeHtml(row.metric)}</strong>：
      实际 ${row.actual} / 预算 ${row.budget} ${escapeHtml(row.unit)}
      （${row.variancePct != null ? `${row.variancePct}%` : '—'}）
    </div>
  `).join('') || '<div>暂无</div>';
    document.getElementById('vc-bridge-list').innerHTML = (result.ebitdaBridge || []).map((row) => `
    <div style="margin-bottom:4px;">
      ${escapeHtml(row.component)}：<strong>${row.impact}</strong> 万元
      <span style="color:#6B7280;"> · ${escapeHtml(row.note)}</span>
    </div>
  `).join('') || '<div>暂无</div>';
    document.getElementById('vc-plan-list').innerHTML = (result.hundredDayPlan || []).map((phase) => `
    <div style="margin-bottom:8px;padding:6px 8px;border:1px solid #E8E4DC;border-radius:4px;background:#FCFAF5;">
      <div style="font-weight:600;">${escapeHtml(phase.phase)} · ${escapeHtml(phase.weekRange)} · ${escapeHtml(phase.priority)}</div>
      <div style="color:#6B7280;margin:2px 0;">${escapeHtml(phase.theme)} · ${escapeHtml(phase.owner)}</div>
      <ul style="margin:4px 0 0 16px;padding:0;">${(phase.actions || []).map((a) => `<li>${escapeHtml(a)}</li>`).join('')}</ul>
    </div>
  `).join('') || '<div>暂无</div>';
    document.getElementById('vc-disclaimer').textContent = result.disclaimer || '';
  }

  document.getElementById('vc-from-project')?.addEventListener('click', function () {
    const input = getCurrentProjectInput();
    if (!input) return;
    document.getElementById('vc-company').value = input.companyName || '';
  });

  document.getElementById('vc-analyze-btn')?.addEventListener('click', async function () {
    const projectId = getCurrentProjectId();
    if (!projectId || projectId === 'draft') {
      showRuntimeError('请先打开或创建项目');
      return;
    }
    const originalText = this.textContent;
    this.disabled = true;
    this.textContent = '分析中...';
    try {
      const payload = collectValueCreationPayload();
      const result = await requestRuntime('/api/business/value-creation/analyze', {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      renderValueCreationResult(result);
      document.getElementById('stage-result-p8v').textContent =
        `价值创造分析完成 · P0 行动 ${result.snapshot?.openP0Actions ?? 0} 项`;
      setRuntimeProgress(100);
    } catch (error) {
      showRuntimeError(error.message);
      setRuntimeProgress(0);
    } finally {
      this.disabled = false;
      this.textContent = originalText;
    }
  });

  document.getElementById('vc-export-btn')?.addEventListener('click', async function () {
    const projectId = getCurrentProjectId();
    if (!projectId || projectId === 'draft') {
      showRuntimeError('请先打开或创建项目');
      return;
    }
    const originalText = this.textContent;
    this.disabled = true;
    this.textContent = '导出中...';
    try {
      const payload = collectValueCreationPayload();
      const result = await requestRuntime('/api/business/value-creation/export-excel', {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      renderValueCreationResult(result);
      if (result.downloadUrl) {
        window.open(result.downloadUrl, '_blank', 'noopener,noreferrer');
      }
      document.getElementById('stage-result-p8v').textContent =
        `Excel 月报已生成：${result.artifactId || ''}`;
    } catch (error) {
      showRuntimeError(error.message);
    } finally {
      this.disabled = false;
      this.textContent = originalText;
    }
  });

  document.getElementById('vc-skill-btn')?.addEventListener('click', async function () {
    const originalText = this.textContent;
    this.disabled = true;
    this.textContent = 'Skill 执行中...';
    try {
      const result = await runProjectSkill('ValueCreationSkill');
      renderValueCreationResult({ result: result.output });
      document.getElementById('stage-result-p8v').textContent =
        `Skill 完成 · ${result.skillName} · ${result.durationMs || 0}ms`;
    } catch (error) {
      showRuntimeError(error.message);
    } finally {
      this.disabled = false;
      this.textContent = originalText;
    }
  });

  return { getLatestValueCreation: () => latestValueCreation };
}
